import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IChannelRepository } from '../../repositories/interfaces/iChannelRepository';
import { IChannelEntity, IGetChannelsParams } from '../../../entity/interface/iChannels';

export interface IGetChannelsArrisSTBUseCase {
    execute(params: IGetChannelsParams): Promise<IChannelEntity[]>;
}

export class GetChannelsArrisSTBUseCase implements IGetChannelsArrisSTBUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelsRepo(): IChannelRepository {
        return container.resolve<IChannelRepository>(DI.REPOSITORIES.IChannelRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetChannelsParams): Promise<IChannelEntity[]> {
        const response = await this.channelsRepo.getChannelsArrisSTB(params);
        return response.data.channels || [];
    }
}
